import React from 'react';
import ContractTypeForm from './ContractTypeForm';

function ContractTypeAdd() {
   return <ContractTypeForm mode="add" />;
}

export default ContractTypeAdd;
